export default "__VITE_ASSET__9TsMtKoQ__"